import { render, staticRenderFns } from "./ServiceCategoryList.vue?vue&type=template&id=6c595e04&"
import script from "./ServiceCategoryList.vue?vue&type=script&lang=js&"
export * from "./ServiceCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports